// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CheckFileOutlinedSvg from "@fishx/icons-svg/es/asn/CheckFileOutlined";
import FishxIcon from '../components/FishxIcon';

var CheckFileOutlined = function CheckFileOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CheckFileOutlinedSvg
  }));
};

CheckFileOutlined.displayName = 'CheckFileOutlined';
export default React.forwardRef(CheckFileOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CheckFileOutlined.js
// module id = 2191
// module chunks = 0